import React from 'react';
import { Layout } from 'react-admin';
import PayPadAppBar from './PayPadAppBar';
import Menu from './Menu';

const PayPadLayout = (props) => <Layout {...props} appBar={PayPadAppBar} menu={Menu} />;

export default PayPadLayout;
